const SOIL_TYPE_KEYS = [
  "soil_type",
  "soilType",
  "SOIL_TYPE",
  "SoilType",
];

const SURFACE_SOIL_TEXTURE_KEYS = [
  "surface_soil_texture",
  "surfaceSoilTexture",
  "SURFACE_SOIL_TEXTURE",
  "SurfaceSoilTexture",
  "soil_texture",
  "soilTexture",
  "SOIL_TEXTURE",
  "SoilTexture",
  "texture",
  "Texture",
  "TEXTURE",
];

const SURFACE_FORM_KEYS = [
  "surface_form",
  "surfaceForm",
  "SURFACE_FORM",
  "SurfaceForm",
  "LF_TYPE",
];

const SLOPE_CLASS_KEYS = [
  "slope_class",
  "slopeClass",
  "SLOPE_CLASS",
  "SlopeClass",
  "LF_SLOPE",
];

const ECODISTRICT_KEYS = [
  "ecodistrict",
  "Ecodistrict",
  "ECODISTRICT",
  "eco_district",
  "ECO_DISTRICT",
  "EcoDistrict",
];

const SLC_POLYGON_KEYS = [
  "slc_polygon",
  "slcPolygon",
  "SLCpolygon",
  "SLCPolygon",
  "SLC_POLYGON",
];

const SOIL_CODE_KEYS = [
  "soil_code",
  "soilCode",
  "SOIL_CODE",
  "SoilCode",
];

const PROVINCE_CODE_KEYS = [
  "province_code",
  "provinceCode",
  "ProvinceCode",
  "PROVINCE_CODE",
];

const PERCENT_KEYS = ["percent", "Percent", "PERCENT"];
const CROPPED_KEYS = ["cropped", "CROPPED", "Cropped"];

function normalizeEnumValue(rawValue, options) {
  if (rawValue == null) {
    return null;
  }

  const normalizedRawValue = String(rawValue).trim().toLowerCase();

  if (!normalizedRawValue) {
    return null;
  }

  const match = options.find((option) => {
    const optionValue = String(option.value || "").trim().toLowerCase();
    const optionLabel = String(option.label || "").trim().toLowerCase();

    return (
      normalizedRawValue === optionValue || normalizedRawValue === optionLabel
    );
  });

  return match?.value ?? null;
}

function findFirstValue(source, keys) {
  if (!source || typeof source !== "object") {
    return null;
  }

  for (const key of keys) {
    if (source[key] != null && String(source[key]).trim() !== "") {
      return source[key];
    }
  }

  return null;
}

function extractResolvedSoilFieldValues(
  soilData,
  {
    soilTypeOptions = [],
    surfaceSoilTextureOptions = [],
    surfaceFormOptions = [],
    slopeClassOptions = [],
  } = {}
) {
  const newValues = {};

  const normalizedResolution = normalizeResolvedSoilResponse(soilData);
  const suggestionSource = soilData?.suggestions || soilData;

  const resolvedSurfaceForm = normalizeEnumValue(
    normalizedResolution.surfaceForm,
    surfaceFormOptions
  );
  const resolvedSlopeClass = normalizeEnumValue(
    normalizedResolution.slopeClass,
    slopeClassOptions
  );

  if (resolvedSurfaceForm) {
    newValues.surface_form = resolvedSurfaceForm;
  }

  if (resolvedSlopeClass) {
    newValues.slope_class = resolvedSlopeClass;
  }

  if (normalizedResolution.ecodistrict != null) {
    newValues.ecodistrict = normalizedResolution.ecodistrict;
  }

  if (normalizedResolution.slcPolygon != null) {
    newValues.slc_polygon = normalizedResolution.slcPolygon;
  }

  if (normalizedResolution.soilCode) {
    newValues.soil_code = normalizedResolution.soilCode;
  }

  const resolvedSoilType = normalizeEnumValue(
    findFirstValue(suggestionSource, SOIL_TYPE_KEYS),
    soilTypeOptions
  );
  const resolvedSurfaceSoilTexture = normalizeEnumValue(
    findFirstValue(suggestionSource, SURFACE_SOIL_TEXTURE_KEYS),
    surfaceSoilTextureOptions
  );

  if (resolvedSoilType) {
    newValues.soil_type = resolvedSoilType;
  }

  if (resolvedSurfaceSoilTexture) {
    newValues.surface_soil_texture = resolvedSurfaceSoilTexture;
  }

  return newValues;
}

function mergeBlankResolvedSoilFieldValues(field, resolvedValues) {
  const merged = { ...field };

  Object.entries(resolvedValues || {}).forEach(([key, value]) => {
    const currentValue = field?.[key];
    const currentIsBlank =
      currentValue === null ||
      currentValue === undefined ||
      String(currentValue).trim() === "";
    const suggestionIsPresent =
      value !== null && value !== undefined && String(value).trim() !== "";

    if (currentIsBlank && suggestionIsPresent) {
      merged[key] = value;
    }
  });

  return merged;
}

function normalizeResolvedSoilResponse(soilData) {
  const source = soilData?.suggestions || soilData;
  return {
    surfaceForm: findFirstValue(source, SURFACE_FORM_KEYS),
    slopeClass: findFirstValue(source, SLOPE_CLASS_KEYS),
    ecodistrict: findFirstValue(source, ECODISTRICT_KEYS),
    slcPolygon: findFirstValue(source, SLC_POLYGON_KEYS),
    soilCode: findFirstValue(source, SOIL_CODE_KEYS),
    provinceCode: findFirstValue(soilData, PROVINCE_CODE_KEYS),
    percent: findFirstValue(source, PERCENT_KEYS),
    cropped: findFirstValue(source, CROPPED_KEYS),
  };
}

export {
  extractResolvedSoilFieldValues,
  mergeBlankResolvedSoilFieldValues,
  normalizeResolvedSoilResponse,
};
